import React, { useState, useRef } from 'react';
import { sendEmailVerification } from 'firebase/auth';
import { auth } from '../config/firebase';
import { useAuth } from '../hooks/useAuth';
import './email-verification-banner.css';

const RESEND_COOLDOWN = 60;

export const EmailVerificationBanner = () => {
  const { currentUser } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  const [sending, setSending] = useState(false);
  const timerRef = useRef(null);

  if (!currentUser || currentUser.emailVerified || dismissed) return null;

  const handleResend = async () => {
    if (cooldown > 0 || sending) return;
    setSending(true);
    try {
      await sendEmailVerification(auth.currentUser);
      let count = RESEND_COOLDOWN;
      setCooldown(count);
      timerRef.current = setInterval(() => {
        count -= 1;
        setCooldown(count);
        if (count <= 0) clearInterval(timerRef.current);
      }, 1000);
    } catch {
      // silently ignore — Firebase rate limits natively
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="evb-banner" role="alert">
      <span className="evb-icon">✉️</span>
      <span className="evb-text">
        Please verify your email address. Check your inbox for a verification link.
      </span>
      <button
        className="evb-resend-btn"
        onClick={handleResend}
        disabled={cooldown > 0 || sending}
      >
        {sending ? 'Sending…' : cooldown > 0 ? `Resend (${cooldown}s)` : 'Resend Email'}
      </button>
      <button className="evb-dismiss" onClick={() => setDismissed(true)} aria-label="Dismiss">
        ✕
      </button>
    </div>
  );
};
